export const options = [
  'Caregiver meetings: the franchisee is organising monthly caregiver meetings (at least 6 in last year).',
  'Club meetings: the franchisee is attending monthly club meetings (at least 9 in the last year).',
  'Age range: all or nearly all (more than 80%) of the children are aged three and four years old.',
  'Dosage: at least three-quarters of children receive a dosage of six hours per week (playgroups) or 20 hours per week (day mothers and ECD centres).',
  'Reports: the Franchisee is submitting child attendance regularly (weekly child attendance received for the last 12 months).',
  'Parent satisfaction: parent satisfaction surveys - 3 surveys with total score from parents of more than 3 (to be collected at the meeting).',
];
